module.exports = __webpack_public_path__ + "static/media/1.a51f55f0.png";